/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { VStack } from 'chakra-v3';
import { Text } from '../Text';

export const NoCredits: React.FC = () => {
  return (
    <VStack
      gap={{ base: 12, md: '48px' }}
      align="center"
      textAlign="center"
      w="100%"
      maxW={{ base: '100%', md: '560px' }}
      mt={{ base: 8, md: '48px' }}
    >
      <VStack gap={{ base: 4, md: '16px' }} align="center" w="100%">
        <Text variant="heroSubheading" color="text.footer">
          No Credits Available
        </Text>
        <Text variant="caption" color="text.footer">
          You need to complete tasks to earn credits before setting up payments.
        </Text>
      </VStack>
    </VStack>
  );
};
